import { SET_BROKER_SOURCE_TYPE } from 'actions';

export function setBrokerSourceType(sourceType: string) {
  return { sourceType, type: SET_BROKER_SOURCE_TYPE };
}
